module.exports = __webpack_public_path__ + "static/media/3playerRoomsPlayed_100_250.92d38874.png";